export default __webpack_public_path__ + "static/media/Clipboard.eaccfad3.svg";